import { takeEvery, call, put } from 'redux-saga/effects'

import makeAPIRequest from 'store/entities/api/sagas'
import { FETCH_AVAILABLE_LANGUAGES, SET_AVAILABLE_LANGUAGES } from 'store/entities/organizations/actionTypes'
import { locizeProjectId } from 'app/config'

export default function* availableOrganizationSaga() {
  yield takeEvery(FETCH_AVAILABLE_LANGUAGES, handleAvailableOrganizationSaga)
}

export function* handleAvailableOrganizationSaga() {
  try {
    const response = yield call(makeAPIRequest, `https://api.locize.io/languages/${locizeProjectId}`, {
      method: 'GET',
    })
    yield put({ type: SET_AVAILABLE_LANGUAGES, payload: response })
  } catch (badResponse) {
    console.log(badResponse)
  }
}
